import type { ReactNode } from "react";

import type { PriceChildren } from "./ItemPrice";
import { ItemPrice } from "./ItemPrice";
import { ItemVendor } from "./ItemVendor";

export interface ItemPriceAndVendorProps {
  vendor: ReactNode;
  price: PriceChildren;
}

export function ItemPriceAndVendor({ vendor, price }: ItemPriceAndVendorProps) {
  return (
    <div className="item--price--vendor">
      {vendor ? (
        <>
          <ItemVendor>{vendor}</ItemVendor>
          {price ? <span>/</span> : null}
        </>
      ) : null}
      {price ? <ItemPrice>{price}</ItemPrice> : null}
    </div>
  );
}
